export default __webpack_public_path__ + "static/af-441f19b17a0230365b1a2fd8bcb4d3e0.svg";